import "../../../../src/content/israel-broadcast-listings/israel-bc-listing.scss";
import * as React from 'react';
export default {
  React
};